export default __webpack_public_path__ + "static/media/user.4a066bb2.png";